<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Business Unit Templates
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="nav-tree">
            <!-- <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add {{btnText}}</el-button> -->
          </div>
          
          <el-table
            max-height="720"
            :data="tableData"
            :empty-text="$t('general_noData')"
            style="width: 100%">
            <el-table-column
              label="ID"
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('settings_taskTreeTamplates_businessUnitTemplates_name')">
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('settings_taskTreeTamplates_businessUnitTemplates_description')">
            </el-table-column>
            <el-table-column
              :label="$t('settings_companies_createDate')"
              width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.createDate">
                  {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                </span>
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column
              width="180"
              :label="$t('settings_taskTreeTamplates_businessUnitTemplates_operations')">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  plain
                  disabled
                  icon="el-icon-share"></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)"></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  @click="handleDelete(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>

    <sweet-modal blocking ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">
      <h1>{{$t('general_edit')}} {{btnText}}</h1>
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input :placeholder="paleceholderText + ` name`" v-model="formEdit.name"></el-input>
        </el-form-item>
        <el-form-item prop="description">
          <el-input :placeholder="paleceholderText + ' description'" type="textarea" v-model="formEdit.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="editItem('formEdit')" class="modal__btn" type="primary" plain size="small">{{$t('general_edit')}} {{btnText}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      SweetModal,
    },
    created () {
      this.loadList()
    },
    data() {
      return {
        paleceholderText: this.$i18n.t('settings_taskTreeTamplates_businessUnitTemplates_buTemplates'),
        btnText: this.$i18n.t('settings_taskTreeTamplates_businessUnitTemplates_buTemplates'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        serviceIndex: null,
        formEdit:{
          name: '',
          description: ''
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          description: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTemplates/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            console.log('---/businessUnitTemplates/list', response.data.list);
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.formEdit.description = ''
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        console.log(row)
        this.selectedRowId = row.id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTemplates/item?companyId=${this.$route.query.companyId}&businessUnitTemplateId=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.description = response.data.item.description
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitTemplates/update?companyId=${this.$route.query.companyId}&businessUnitTemplateId=${this.selectedRowId}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id

        this.$confirm('This will permanently delete the templates. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/businessUnitTemplates/delete?companyId=${this.$route.query.companyId}&businessUnitTemplateId=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
